/// <reference path='../../interfaces/interfaces.d.ts' />

import Moment = moment.Moment;
import * as _ from 'lodash';

'use strict';

class EmployeeSelectDirective {

    public restrict;
    public require;
    public scope;
    public template;
    public replace;

    constructor(private Employee: IEmpService,
                private toaster: toaster.IToasterService) {
        this.restrict = 'E';
        this.scope = {
            model: '='
        };
        this.replace = true;
        this.template = `
            <div>
                <angucomplete-alt
                    placeholder="Start typing employee name..."
                    initial-value="employee"
                    selected-object="selectEmployee"
                    local-data="employees"
                    search-fields="displayname"
                    title-field="displayname"
                    minlength="1"
                    input-class="form-control"
                    ng-class="{disabled: disabled}"
                    ng-show="loaded"
                    focus-out="focusOut"
                    />
            </div>
            `
        /*
            <!--<div class="btn-group">
                <a class="btn btn-raised dropdown-toggle"
                    data-toggle="dropdown"
                    aria-expanded="false"
                    data-ng-class="{ 'disabled': disabled }"
                    data-ng-show="loaded">
                    {{ activeElem }}
                    <span class="caret"></span>
                    <div class="ripple-container"></div>
                </a>
                <div data-ng-show="!loaded">Loading employee list...</div>
                <ul class="dropdown-menu">
                    <li data-ng-repeat="employee in employees track by $index"
                        data-ng-click="selectEmployee(employee, $index)"
                        data-ng-class="{'active': activeElemIndex == $index}">
                        <a href="" data-ng-bind="::employee.displayname"></a>
                    </li>
                </ul>
            </div>-->
        */
    }

    public link = (scope: any) => {
        scope.activeElemIndex = -1;
        scope.activeElem = '';
        scope.employee = undefined
        scope.loaded = false;
        this.Employee.names('', scope.$parent.evalExpr("C.org_id")).then((response: any) => {
            scope.employees = response;
            scope.activeElemIndex = _.findIndex(scope.employees, { 'id': scope.model });
            if (scope.activeElemIndex >= 0) {
                scope.activeElem = scope.employees[scope.activeElemIndex].displayname;
                scope.employee = scope.employees[scope.activeElemIndex]
            }
            scope.loaded = true;
        }, () => {
            this.toaster.pop('error', 'Loading failed', 'Failed loading employee list');
            scope.loaded = true;
        });

        scope.selectEmployee = function (item: any) {
            if (item !== undefined) {
                let employee = item.originalObject
                let index = this.$parent.$index
                scope.employee = employee
                scope.model = employee.id;
                scope.activeElem = employee.displayname;
                scope.activeElemIndex = index;
            } else {
                scope.activeElemIndex = -1
                scope.activeElem = ''
                scope.employee = undefined
                scope.model = undefined
            }
        };

        scope.focusOut = function () {
            if (scope.employee === undefined) {
                scope.$broadcast('angucomplete-alt:changeInput', '', undefined);
            }
        }
    };

    public static DirectiveFn(Employee: any, toaster: toaster.IToasterService): EmployeeSelectDirective {
        return new EmployeeSelectDirective(Employee, toaster);
    }
}

EmployeeSelectDirective.DirectiveFn.$inject = ['Employee', 'toaster'];

angular.module('beneple.global').directive('employeeSelect', EmployeeSelectDirective.DirectiveFn);



// WEBPACK FOOTER //
// ./frontend/scripts/schemaForm/directives/employee_select.directive.ts